import config from 'config';
import { Quill } from 'react-quill';
import { notEmpty } from 'util/arrayUtils';

const BlockEmbed = Quill.import('blots/block/embed');

export const COMPANY_BLOT_CLASS = 'ql-company-embed';
class CompanyBlot extends BlockEmbed {
  static blotName = 'companyBlot';
  static tagName = 'div';
  static className = COMPANY_BLOT_CLASS;
  static create(value: { slugs: string[]; ids: string[]; isDetailed: boolean; isGrid: boolean }): HTMLElement {
    const node = document.createElement('div');
    node.classList.add(this.className);
    const portalUrl = config.PORTAL_URL;
    if (value.isGrid) {
      node.classList.add('ql-company-embed-grid');
    }
    if (value.isDetailed) {
      node.classList.add('ql-company-embed-detailed');
    }

    value.slugs.forEach((slug, index) => {
      const iframe = document.createElement('iframe');
      const id = value.ids[index];
      iframe.src = `${portalUrl}/embed/companies/${slug}/${value.isDetailed ? 'detailed' : ''}?id=${id}`;
      node.appendChild(iframe);
    });

    return node;
  }

  format(name: string, value: { slugs: string[]; ids: string[]; isDetailed: boolean; isGrid: boolean }) {
    if (name === 'slugs') {
      if (value.isGrid) {
        this.domNode.classList.add('ql-company-embed-grid');
      } else {
        this.domNode.classList.remove('ql-company-embed-grid');
      }

      if (value.isDetailed) {
        this.domNode.classList.add('ql-company-embed-detailed');
      } else {
        this.domNode.classList.remove('ql-company-embed-detailed');
      }
      this.domNode.innerHTML = '';

      value.slugs.forEach((slug: string, index: number) => {
        const iframe = document.createElement('iframe');
        const id = value.ids[index];
        iframe.src = `${config.PORTAL_URL}/embed/companies/${slug}/${value.isDetailed ? 'detailed' : ''}?id=${id}`;

        this.domNode.appendChild(iframe);
      });
    }
  }
  static formats(node: HTMLElement) {
    return this.value(node);
  }

  static value(node: HTMLElement) {
    const iframes = Array.from(node.children) as HTMLIFrameElement[];

    const urls = iframes.map((child: HTMLElement) => child.getAttribute('src') || '');
    const slugs = urls
      .map(url => {
        const match = url.match(/\/companies\/([\w-]+)/);
        return match && match[1];
      })
      .filter(notEmpty);
    const ids = urls.map(url => {
      const match = url.match(/id=([\w-]+)/);
      return match && match[1];
    });

    const isGrid = node.classList.contains('ql-company-embed-grid');
    const isDetailed = node.classList.contains('ql-company-embed-detailed');
    return { slugs, isGrid, isDetailed, ids };
  }
}

Quill.register('formats/companyBlot', CompanyBlot);
